/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-05-16T17:00:11.367
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listEvaluateAppointmentFinal,
	listEvaluateAppointmentFinalInit,
	listEvaluateAppointmentFinalByAuthorizations,
	deleteEvaluateAppointmentFinal
	
} from '@api/storagemanage/EvaluateAppointmentFinal';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listEvaluateAppointmentFinal({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluateAppointmentFinal(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listEvaluateAppointmentFinalByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluateAppointmentFinalByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listEvaluateAppointmentFinalInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listEvaluateAppointmentFinalInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteEvaluateAppointmentFinal({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteEvaluateAppointmentFinal({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
